import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { AdminController } from '../../../controllers';
import constant from '../../../utils/constant';
import { MimaToastUtil } from '../../../components';
import { useFormik } from 'formik';
import { adminStore, catalogStore } from '../../../stores';

const useAdminLoginLogic = () => {
	const navigate = useNavigate();
	const {
		businessEmail,
		setToken,
		setLoggedIn,
		setBusinessId,
		setAdminUserId,
		setAdminUser,
		setAdminBusiness,
	} = adminStore;
	const { setEditMode } = catalogStore;
	const initialValues = {
		email: '',
		password: '',
	};

	const validationSchema = yup.object().shape({
		email: yup.string().email('Invalid email').required('Email is required'),
		password: yup.string().required('Password is required'),
	});

	const onSubmit = async values => {
		const payload = {
			userEmailMobile: values.email,
			password: values.password,
			accountType: 'Business',
		};

		const { status, data, errorMessage } = await AdminController.login(payload);
		if (status === constant.Success) {
			const { token, user } = data || {};

			if (
				user?.email?.toLowerCase() !== businessEmail?.toLowerCase() &&
				values.email.toLowerCase() !== user?.email?.toLowerCase()
			) {
				MimaToastUtil.error({
					message:
						'Unauthorized: Email or password does not match this websites Admin records.',
				});
			} else if (
				user.business.subscription?.status === constant.PLAN_STATUS.EXPIRED
			) {
				MimaToastUtil.error({
					message:
						'Your subscription has expired. Please visit the Fash app or website to renew your subscription or contact support for assistance.',
				});
			} else {
				setToken(token);
				setLoggedIn(true);
				setBusinessId(user.business._id);
				setAdminUserId(user._id);
				setAdminUser(user);
				setAdminBusiness(user.business);
				setEditMode(true);

				return navigate(constant.Routes.Admin.Dashboard);
			}
		} else if (data?.activated === false) {
			MimaToastUtil.error({
				message:
					'Your account has not been activated. Please visit the Fash app to activate or contact support for assistance.',
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit,
	});

	return {
		formik,
	};
};

export default useAdminLoginLogic;
